import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { onError } from '@apollo/client/link/error'

import { emitContextChanged } from '@/utils/contextChangedEvent'

const isContextInvalidationText = (value: unknown): boolean => {
  const normalized = String(value ?? '').toLowerCase()
  return (
    normalized.includes('invalid context') ||
    normalized.includes('context iri') ||
    normalized.includes('x-communo-context-iri')
  )
}

/**
 * Error link to handle context-related errors
 * If the backend returns an error indicating the context is invalid,
 * we clear the context from localStorage
 */
export const ApolloContextErrorLink = onError(({ error, operation }) => {
  if (CombinedGraphQLErrors.is(error)) {
    for (const { message, extensions } of error.errors) {
      // Check only explicit context invalidation signals.
      // Do NOT treat generic 403/forbidden as context-invalid.
      const code = String(extensions?.code ?? '').toUpperCase()
      const hasContextInvalidCode =
        code === 'CONTEXT_INVALID' ||
        code === 'INVALID_CONTEXT' ||
        code === 'INVALID_CONTEXT_IRI'
      const hasContextInvalidText = isContextInvalidationText(message)
      const isContextError = hasContextInvalidCode || hasContextInvalidText

      if (isContextError && operation.operationName !== 'authUser') {
        // Clear invalid context
        localStorage.removeItem('contextIri')
        localStorage.removeItem('contextName')
        emitContextChanged('ApolloContextErrorLink:graphQLError')
      }
    }
  } else if (error) {
    // Handle only explicit context-invalid network errors
    const hasContextInvalidText = isContextInvalidationText(error)
    if (hasContextInvalidText) {
      localStorage.removeItem('contextIri')
      localStorage.removeItem('contextName')
      emitContextChanged('ApolloContextErrorLink:networkError')
    }
  }
})
